<template>
    <div class="title-div">
        <p>Verify Email</p>
        <!-- <div class="flex justify-center items-center rounded-lg text-[#A4A7AE] cursor-pointer" @click="close">
            <XMarkIcon class="h-[24px] w-[24px]" />
        </div> -->
    </div>
    <div class="sub-div">
        <p>
            Enter the verification code sent to the below email to add it to your Identity Vault. We'll start scanning for
            exposures linked to it.
            <span class="block mt-1">
                Email: <span class="font-bold">{{ dialogRef.data.email }}</span>
            </span>
        </p>
    </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { ModalNames } from '~/types/modals';

//dialog ref
const dialogRef = getDialogRef(ModalNames.EMAIL_VERIFICATION);

const emit = defineEmits(['closeDialog']);

const close = () => {
    emit('closeDialog');
};
</script>
<style lang="scss" scoped>
.title-div {
    @apply flex flex-row justify-between w-full;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.sub-div {
    @apply self-stretch;

    p {
        @apply text-gray-600 text-sm font-normal leading-5 font-inter;
    }
}
</style>